<!--
 * @Author: Lemon C
 * @Date: 2024-05-13 11:21:52
 * @LastEditTime: 2024-08-05 18:30:28
-->
<template>
    <div class="sup-web-iframe">
        <iframe ref="ref_iframe" src="preview/demoPreview.html" frameborder="0" scrolling="no" style="width: 100%; height: 100%"></iframe>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted } from 'vue';

const ref_iframe = ref(null);
const iframeWin = ref(null);
const web_iframe_post_msg = ref('');

onMounted(() => {
    iframeWin.value = ref_iframe.value.contentWindow;
});

// MARK 接收iframe信息
const iframe_update = (content) => {
    web_iframe_post_msg.value = content;
    iframe_post_msg();
};

// MARK 设置iframe信息
const iframe_post_msg = () => {
    iframeWin.value.postMessage({ content: web_iframe_post_msg.value });
};

// MARK 将 update_data 方法暴露给父组件
defineExpose({
    iframe_update,
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-web-iframe {
    display: flex;
    background: var(--color-main-light-bg);
}
</style>
